import(/* webpackMode: "eager" */ "/opt/build/repo/app/auth/signup/page.jsx");
